import WithExportRestriction from './WithExportRestriction';

export default WithExportRestriction;
